<template>
  <div style="position: relative">
    <!-- 头部导航栏 -->
    <div class="header">
      <div class="content flex align-items-center">
        <div class="logo" @click="goIndex">
          <img src="@/assets/images/home/logo.png" alt="" />
        </div>
        <div class="menu_box">
          <ul class="flex">
            <li
              class="navigation-text"
              :class="{ active: active == '首页' }"
              @click="goIndex"
            >
              首页
            </li>
            <li
              :class="{ active: active == 'ZZ' }"
              @mouseenter="enterShow('ZZ')"
              @mouseleave="enterShow('2')"
            >
              <div>
                <span class="navigation-text" @click="goCourseCenter('ZZ')"
                  >中职课程</span
                >
                <span class="iconfont" style="color: #fff">&#xe642;</span>
                <transition name="fade">
                  <select-courses
                    v-show="zzCourseShow"
                    :active="active"
                    ref="selectCoursezz"
                    :id="zzId"
                    style="z-index: 10000; border-top: 3px solid #f3f5f9"
                  >
                  </select-courses>
                </transition>
                <!-- sdjkalsjdklsajkdl  -->
              </div>
            </li>
            <!-- @click="$router.push({ name: 'HgcourseDetail' })" -->
            <li
              :class="{ active: active == 'GZ' }"
              @mouseenter="enterShow('GZ')"
              @mouseleave="enterShow('2')"
            >
              <div>
                <span class="navigation-text" @click="goCourseCenter('GZ')"
                  >高职课程</span
                >
                <span class="iconfont" style="color: #ffffff">&#xe642;</span>
                <select-courses
                  v-if="gzCourseShow"
                  ref="selectCoursegz"
                  :active="active"
                  :id="gzId"
                  style="z-index: 10000; border-top: 3px solid #f3f5f9"
                ></select-courses>
              </div>
            </li>
            <!--  @click="handleCertifivate" -->
            <li style="margin-right: 37px">
              <div class="navigation-text" @click="handleCertifivate">
                1+X证书
              </div>
            </li>
            <li style="margin-right: 37px">
              <div class="navigation-text" @click="gotoQuery">证书查询</div>
            </li>
            <!-- <li style="margin-right: 37px">
              <div class="navigation-text">APP下载</div>
            </li> -->
            <li>
              <div class="navigation-text">帮助中心</div>
            </li>
          </ul>
        </div>
        <!-- <div class="flex search-box">
          <input type="text" placeholder="搜索课程/老师/学校" />
          <div><span class="iconfont" style="color: #fff">&#xe651;</span></div>
        </div> -->
        <div
          class="user-info-box flex align-items-center flex-center"
          v-if="loginState"
        >
          <el-dropdown>
            <div class="avatar-box">
              <img
                style="
                  display: inline-block;
                  vertical-align: middle;
                  height: 35px;
                  width: 35px;
                  line-height: 35px;
                  border-radius: 50%;
                "
                :src="BaseImgUrl + userInfo.avatar"
                alt=""
                @error="headError"
              />
              <span class="people-name" :title="userInfo.realname">
                {{ userInfo.realname }}
              </span>
              <span class="iconfont" style="margin-left: 5px; color: #fff"
                >&#xe642;</span
              >
            </div>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="goPersonalCenter"
                >个人中心</el-dropdown-item
              >
              <!-- -->
              <el-dropdown-item
                @click.native="goMyTeaching"
                v-if="
                  userIdentity && userIdentity == 1 && isAuthentication == 1
                "
                >我的教学</el-dropdown-item
              >
              <el-dropdown-item @click.native="goMyStudy"
                >我的学习</el-dropdown-item
              >
              <el-dropdown-item
                v-if="
                  userIdentity && userIdentity == 1 && $store.state.userInfo
                    ? isShow()
                    : false
                "
                @click.native="goMyProject"
                >项目管理</el-dropdown-item
              >
              <!-- updateBy=='admin' &&userIdentity!=1    isOrganManager==1-->
              <el-dropdown-item
                v-if="
                  userIdentity &&
                  userIdentity == 1 &&
                  $store.state.schoolPermission.indexOf('学校管理') != -1
                "
                @click.native="goSchoolManage"
                >学校管理</el-dropdown-item
              >
              <el-dropdown-item
                divided
                v-show="schoolUserStatus == 0 && isAuthentication == 1"
              >
                当前机构：
                <span style="color: #006cff">{{ organName }}</span>
              </el-dropdown-item>
              <el-dropdown-item
                :divided="schoolUserStatus != 0 || isAuthentication == 0"
                >用户身份：
                <span style="color: #006cff">{{
                  userIdentity == 1
                    ? isAuthentication == 1
                      ? "教师"
                      : "学生"
                    : userIdentity == 2
                    ? "学生"
                    : ""
                }}</span>
              </el-dropdown-item>
              <el-dropdown-item @click.native="logout"
                ><span>退出登录</span></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="user-info-box flex align-items-center flex-center" v-else>
          <span class="noLogin noLogin-all" @click="$router.push(`/login/${0}`)"
            >登录</span
          >
          <span class="noLogin-all" @click="$router.push(`/login/${1}`)"
            >注册</span
          >
        </div>
      </div>
    </div>

    <div class="course-center" v-if="pathname == '/course/center'"></div>
    <router-view v-if="isRouterAlive"></router-view>
    <!-- 底部 -->
    <footers />
    <!-- 右侧小按钮 -->
    <div class="right_button">
      <div
        v-if="
          pathname != '/index' && pathname != '/course/center' && loginState
        "
      >
        <div
          class="tool-cabinet"
          v-if="
            ($route.path.slice(0, 19) == '/teacher/myTeaching' ||
              $route.path.slice(0, 23) == '/teacher/courseLearning') &&
            iconList.length > 0
          "
        >
          <img
            class="ai-icon"
            src="@/assets/images/aiIcon/ai-icon.png"
            title="AI工具箱"
          />
          <div class="tool-box">
            <img
              class="ai-arrows"
              src="@/assets/images/aiIcon/ai-arrows.png"
              alt=""
            />
            <div class="tool-box-list">
              <div
                class="tool-item"
                v-for="(item, index) in iconList"
                :key="index"
                @click="goIconHref(item)"
              >
                <img :src="BaseImgUrl + item.coverImg" alt="" />
                <span>{{ item.aiMode }}</span>
              </div>
            </div>
          </div>
        </div>
        <p
          v-if="
            ($route.path.slice(0, 19) == '/teacher/myTeaching' ||
              $route.path.slice(0, 23) == '/teacher/courseLearning') &&
            iconList.length > 0
          "
        ></p>

        <div v-if="userOrganList && userOrganList.length > 1">
          <!-- <div>机构切换</div> -->
          <el-dropdown>
            <span class="el-dropdown-link" style="color: #9ba6b9"
              >机构切换</span
            >
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in userOrganList"
                :key="index"
                @click.native="handleSchool(item)"
                >{{ item.organName }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <p v-if="userOrganList && userOrganList.length > 1"></p>
        <!-- &&userIdentity!=1 &&userIdentity!=1   isOrganManager==1-->

        <div
          v-if="
            userIdentity &&
            userIdentity != 2 &&
            $store.state.schoolPermission.indexOf('学校管理') != -1
          "
          @click="goSchoolManage"
        >
          <div>学校管理</div>
        </div>
        <p
          v-if="
            userIdentity &&
            userIdentity != 2 &&
            $store.state.schoolPermission.indexOf('学校管理') != -1
          "
        ></p>
        <div @click="goMyStudy">
          <div>我的学习</div>
        </div>
        <p></p>
        <div
          v-if="userIdentity && userIdentity == 1 && isAuthentication == 1"
          @click="goMyTeaching"
        >
          <div>我的教学</div>
        </div>
        <p
          v-if="userIdentity && userIdentity == 1 && isAuthentication == 1"
        ></p>
      </div>
      <div>
        <div>
          <img src="@/assets/images/question-mark.png" alt="" />
        </div>
        <p></p>
        <div class="icon-app" style="position: relative">
          <img src="@/assets/images/app.png" alt="" />
          <div class="app-dialog">
            <img src="@/assets/images/app-code.png" alt="" />
          </div>
        </div>
        <p></p>
        <div @click="backTop">
          <img src="@/assets/images/shape.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import footers from "@/components/footer.vue";
import selectCourses from "./components/selectCourses.vue";
import { getMajorTree } from "@/api/personage.js";
import { BaseUrl, BaseImgUrl, getAction } from "@/api/index.js";
import axios from "axios";
export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      BaseUrl,
      BaseImgUrl,
      loginState: localStorage.getItem("userState")
        ? localStorage.getItem("userState")
        : "",
      userInfo: this.$store.state.userInfo,
      // gzmajorClassList: [], //高职专业大类
      // zzmajorClassList: [], //中职专业大类
      // gzsecondaryClassList: [], //高职子类
      // zzsecondaryClassList: [], //中职子类
      // active: this.$store.state.courseType,
      active: "首页",
      gzId: "",
      zzId: "",
      zzCourseShow: false,
      gzCourseShow: false,
      isRouterAlive: true,
      pathname: "", //当前页的url
      organName: this.$store.state.userInfo.organName, //机构名称
      userIdentity: this.$store.state.userInfo.userIdentity, //用户类型    1-教师  2-学生
      isAuthentication: this.$store.state.userInfo.isAuthentication, //认证状态   0-未认证  1-已认证
      schoolUserStatus: this.$store.state.userInfo.schoolUserStatus, //用户状态   0-启用 1-停用
      isOrganManager: this.$store.state.userInfo.isOrganManager, //学校管理员   0-不是 1-是
      userState: localStorage.getItem("userState"),
      updateBy: this.$store.state.userInfo.updateBy,
      timer: null,
      userOrganList: this.$store.state.userInfo.userOrganList,
      iconList: [],
    };
  },
  watch: {
    pathname(newVal, oldVal) {
      if (newVal == "111") {
        this.organName = this.$store.state.userInfo.organName; //机构名称
        this.userIdentity = this.$store.state.userInfo.userIdentity; //用户类型    1-教师  2-学生
        this.isAuthentication = this.$store.state.userInfo.isAuthentication; //认证状态   0-未认证  1-已认证
        this.schoolUserStatus = this.$store.state.userInfo.schoolUserStatus; //用户状态   0-启用 1-停用
        this.userOrganList = this.$store.state.userInfo.userOrganList;
      }
    },
    userState(newVal, oldVal) {
      console.log(newVal, oldVal);
    },
  },
  created() {
    // debugger
  },
  mounted() {
    this.refreshData();
    // debugger
    // debugger
    this.organName = this.$store.state.userInfo.organName;
    this.pathname = window.location.pathname;
    this.userOrganList = this.$store.state.userInfo.userOrganList;
    this.active =
      localStorage.getItem("courseType") == ""
        ? "首页"
        : localStorage.getItem("courseType");
    this.$store.commit("courseType", "");
    this.getIconList();
  },
  methods: {
    gotoQuery() {
      this.$router.push("/certificateQuery");
    },
    // 破图显示默认图片
    headError(e) {
      e.target.src = require("@/assets/images/head-portrait.png");
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    refreshData() {
      // this.getMajorKind("GZ");
      // this.getMajorKind("ZZ");
      getMajorTree({ classify: "ZZ" }).then((res) => {
        if (res.data.code == 200) {
          this.zzId = res.data.result[0].id;
          // this.$store.commit('majorClassId', this.zzId);
          this.$store.commit("zzMajorTree", res.data.result);
          // this.$store.commit('majorClassName', res.data.result[0].name);
        }
      });
      getMajorTree({ classify: "GZ" }).then((res) => {
        if (res.data.code == 200) {
          this.gzId = res.data.result[0].id;
          // this.$store.commit('majorClassId', this.gzId);
          this.$store.commit("gzMajorTree", res.data.result);
          // this.$store.commit('majorClassName', res.data.result[0].name);
        }
      });
    },
    //机构切换
    handleSchool(item) {
      this.$store.state.userInfo.workNo = item.jobNumber;
      this.$store.state.userInfo.organId = item.organId;
      this.$store.state.userInfo.organName = item.organName;
      this.$store.state.userInfo.isAuthentication = item.isAuthentication;
      this.$store.state.userInfo.userIdentity = item.userIdentity;
      this.$store.state.userInfo.schoolUserStatus = item.schoolUserStatus;
      this.$store.state.userInfo.organSchoolPermission =
        item.organSchoolPermission;
      this.$store.state.schoolPermission = item.organSchoolPermission;
      this.organName = item.organName; //机构名称
      this.userIdentity = item.userIdentity; //用户类型    1-教师  2-学生
      this.isAuthentication = item.isAuthentication; //认证状态   0-未认证  1-已认证
      this.schoolUserStatus = item.schoolUserStatus; //用户状态   0-启用 1-停用
      this.$router.push("/");
      this.pathname = "/index";
      //机构切换
      getAction("/sys/user/editOrganId", {
        username: this.$store.state.userInfo.username,
        organId: this.$store.state.userInfo.organId,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("机构切换成功！");
        }
      });
    },
    // //获取专业大类
    // getMajorKind(curseType) {
    //   getMajorKind({ classify: curseType }).then((res) => {
    //     if (res.data.code == 200) {
    //       if (curseType == "GZ") {
    //         this.gzmajorClassList = res.data.result;
    //         this.gzId = this.gzmajorClassList[0].id;
    //         this.$store.commit("gzMajorClassInfor",res.data.result)
    //         this.$store.commit("majorClassId",this.gzId)
    //         this.$store.commit("majorClassName",this.gzmajorClassList[0].name)
    //         // this.getProfessionalSubclass(curseType, this.gzId);
    //       } else {
    //         this.zzmajorClassList = res.data.result;
    //         this.zzId = this.zzmajorClassList[0].id;
    //         this.$store.commit("zzMajorClassInfor",res.data.result)
    //         this.$store.commit("majorClassId",this.zzId)
    //         this.$store.commit("majorClassName",this.zzmajorClassList[0].name)
    //         // this.getProfessionalSubclass(curseType, this.zzId);
    //       }
    //     }
    //   });
    // },
    // //获取专业子类和专业
    // getProfessionalSubclass(curseType, gategoryId) {
    //   getProfessionalSubclass({ gategoryId: gategoryId }).then((res1) => {
    //     if (res1.data.code == 200) {
    //       if (curseType == "GZ") {
    //         this.gzsecondaryClassList = res1.data.result;
    //         this.getMajor(this.gzsecondaryClassList);
    //       } else {
    //         this.zzsecondaryClassList = res1.data.result;
    //         this.getMajor(this.zzsecondaryClassList);
    //       }
    //     }
    //   });
    // },
    // getMajor(secondaryClassList) {
    //   secondaryClassList.forEach((item, index) => {
    //     item.major = [];
    //     getMajor({ subclassId: item.id }).then((res2) => {
    //       item.major = res2.data.result;
    //     });
    //   });
    // },
    enterShow(num) {
      this.gzCourseShow = false;
      this.zzCourseShow = false;
      if (num == "ZZ") {
        this.active = "ZZ";
        this.timer = setTimeout(() => {
          this.zzCourseShow = true;
        }, 500);
      } else if (num == "GZ") {
        this.active = "GZ";
        this.timer = setTimeout(() => {
          this.gzCourseShow = true;
        }, 500);
      } else {
        clearTimeout(this.timer);
        this.active = this.$store.state.courseType;
        this.gzCourseShow = false;
        this.zzCourseShow = false;
      }
    },
    logout() {
      // localStorage.clear();
      // localStorage.clear()
      this.$store.commit("courseInfo", {});
      window.localStorage.clear();
      this.$router.push("/supplierAllBack");
      // location.reload();
    },
    // 去课程中心页
    goCourseCenter(type) {
      this.$store.commit("courseType", type);
      localStorage.setItem("courseType", type);
      this.active = type;
      this.$store.commit("majorClassId", "");
      this.gzCourseShow = false;
      this.zzCourseShow = false;
      if (window.location.pathname.slice(0, 14) == "/course/center") {
        this.$router.push({
          path: "/course/center",
          query: {
            type: type,
          },
        });
        this.reload();
      } else {
        this.$router.push({
          path: "/course/center",
          query: {
            type: type,
          },
        });
      }
    },
    //1+x证书
    handleCertifivate() {
      this.$router.push({ name: "xcertificate" });
    },
    //去我的教学页面
    goMyTeaching() {
      this.active = "";
      this.$store.commit("courseType", "");
      localStorage.setItem("courseType", "");
      this.$router.push({ name: "myTeaching" });
    },
    goPersonalCenter() {
      this.active = "";
      this.$store.commit("courseType", "");
      localStorage.setItem("courseType", "");
      this.$router.push({ name: "personalCenter" });
    },
    // 我的学习
    goMyStudy() {
      this.$router.push({ name: "myStudy" });
    },

    goMyProject() {
      this.$router.push({ name: "projectIndex" });
    },
    //学校管理
    goSchoolManage() {
      this.$router.push({ name: "schoolManage" });
    },
    goIndex() {
      this.active = "首页";
      this.$store.commit("courseType", "首页");
      localStorage.setItem("courseType", "首页");
      this.$router.push("/supplierAllBack");
    },
    backTop() {
      // document.body.scrollTop = 0;
      // document.documentElement.scrollTop = 0;
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    isShow() {
      if (this.$store.state.userInfo.majorProjectPermission) {
        return this.$store.state.userInfo.majorProjectPermission.includes(
          "项目管理"
        );
      }
    },
    getIconList() {
      if (!this.$store.state.courseInfo.courseId) {
        return;
      }
      let params = {
        courseId: this.$store.state.courseInfo.courseId,
      };
      getAction("/aiconfig/teachCourseAi/getCourseAi", params).then((res) => {
        if (res.data.code == 200) {
          this.iconList = res.data.result;
        }
      });
    },
    goIconHref(item) {
      window.open(item.linkUrl, "_blank");
    },
  },
  components: {
    selectCourses,
    footers,
  },
};
</script>

<style scoped lang="scss">
.header {
  // background: #ffffff;
  min-width: 1200px;
  background: url(~@/assets/images/home/navigation-bar.png) no-repeat;
  background-size: cover;
  box-sizing: border-box;
  .content {
    width: 1200px;
    height: 80px;
    margin: 0 auto;
    position: relative;
    .logo {
      cursor: pointer;
      span {
        font-size: 21px;
        font-family: FZZhengHeiS-M-GB;
        font-weight: bold;
        color: #000000;
        line-height: 56px;
        position: relative;
        bottom: 4px;
        left: 12px;
      }
      img {
        width: 246px;
        height: 36px;
      }
    }
    .menu_box {
      margin-left: 50px;
      height: 100%;
      line-height: 80px;
      ul {
        li {
          margin-right: 40px;
          font-size: 16px;
          cursor: pointer;
          font-size: 18px;
          font-weight: bold;
          color: #ffffff;
          // .navigation-text {
          //   font-size: 18px;
          //   font-weight: bold;
          //   color: #ffffff;
          // }
        }
        // > li:hover {
        //   .navigation-text {
        //     font-size: 18px;
        //     font-weight: bold;
        //     color: #006cff !important;
        //   }
        // }
      }
    }
    .search-box {
      margin-right: 12px;
      input {
        width: 225px;
        height: 38px;
        padding: 0 11px;
        border: 1px solid #006cff;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      div {
        width: 57px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        background: #006cff;
        border: 1px solid #006cff;
        border-radius: 0px 4px 4px 0px;
        cursor: pointer;
      }
    }
    .user-info-box {
      position: absolute;
      right: 0;
      .avatar-box {
        // width: 35px;
        // height: 35px;
        margin-left: 10px;
        margin-right: 8px;
        // border-radius: 50%;
        overflow: hidden;
        cursor: pointer;
      }
      .people-name {
        width: 55px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        top: 4px;
        text-align: center;
        color: #fff;
      }
      .noLogin::after {
        content: "|";
        color: #ffffff;
        margin: 0 5px;
      }
      .noLogin {
        color: #ffffff;
      }
      .noLogin-all {
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}
.right_button {
  width: 62px;
  // height: 190px;
  background: #ffffff;
  box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
  border-radius: 10px;
  position: fixed;
  right: 2%;
  bottom: 10%;
  padding: 20px 0;
  z-index: 100;
  div {
    cursor: pointer;
    text-align: center;
    div {
      width: 29px;
      font-size: 14px;
      font-weight: 400;
      color: #9ba6b9;
      margin: auto;
    }
  }
  p {
    height: 1px;
    width: 80%;
    background-color: #d2d5db;
    margin: 10px auto;
  }
  .icon-app {
    overflow: hidden;
  }
  .icon-app:hover {
    overflow: visible;
    .app-dialog {
      opacity: 1;
      width: 150px;
      height: 150px;
    }
  }
  .app-dialog {
    opacity: 0;
    transition: 0.5s;
    position: absolute;
    width: 0;
    height: 0;
    border: 1px solid #fff;
    box-sizing: border-box;
    font-size: 14px;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
    top: 50%;
    transform: translateY(-50%);
    right: 60px;
    border-radius: 5px;
    background-color: #fff;
    > img {
      width: 100%;
      height: 100%;
    }
  }
  .app-dialog::after,
  .app-dialog::before {
    position: absolute;
    content: "";
    border: 10px solid;
    top: 50%;
    transform: translateY(-50%);
    right: -21px;
  }
  .app-dialog::after {
    border-color: transparent transparent transparent #fff;
  }
  .app-dialog::before {
    border-color: transparent transparent transparent #000;
  }
  .tool-cabinet {
    position: relative;
    .ai-icon {
      width: 100%;
    }
    .tool-box {
      opacity: 0;
      transition: 1s;
      position: absolute;
      width: 340px;
      // min-height: 370px;
      box-sizing: border-box;
      font-size: 14px;
      top: -66px;
      right: 80px;
      border-radius: 10px;
      background: #ffffff;
      visibility: hidden;
      box-shadow: 0 0 10px 0px #d6e6ff;
      cursor: auto;
      .ai-arrows {
        position: absolute;
        right: -50px;
        top: 65px;
      }
      .tool-box-list {
        width: 100%;
        margin: 0;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 18px 12px 6px 12px;
        box-sizing: border-box;
        cursor: auto;
      }
      .tool-item {
        width: 152px;
        height: 52px;
        background: #f7f8fa;
        border-radius: 6px 6px 6px 6px;
        margin: 0 0 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 28px;
          margin-right: 12px;
        }
        span {
          font-size: 16px;
          color: #434343;
        }
      }
      .tool-item:hover {
        box-shadow: 0px 0px 8px 0px #bed6f8;
      }
    }
  }
  .tool-cabinet:hover {
    overflow: visible;
    .tool-box {
      opacity: 1;
      width: 340px;
      // height: 370px;
      // display: block;
      visibility: visible;
    }
  }
}
// .active {
//   color: #006cff !important;
// }
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.course-center {
  width: 100%;
  height: 688px;
  background: url(~@/assets/images/course/course-center.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 80px;
  z-index: -1;
}
</style>
